import GlobalConfig from './GlobalConfig'
import Filters from './Filters'
import Directives from './Directives'
import Axios from './Axios'
import Lodash from './Lodash'
import SharedComponents from './SharedComponents'
import Permissions from './Permissions'
import Forms from './Forms'
import ProgressBar from './ProgressBar'
import Lang from './Lang';
import Snotify from './Snotify';
import VueSelect from './VueSelect';
import Excel from './Excel';
import VueIdle from './VueIdle'
// import PerfectScrollbar from './PerfectScrollbar';
import Moment from './Moment';
import PrintToPaper from './PrintToPaper';

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }
                
        Vue.use(GlobalConfig);
        Vue.use(Lang);
        Vue.use(Lodash);
        Vue.use(Moment);
        Vue.use(Axios);
        Vue.use(SharedComponents);
        Vue.use(Permissions);
        Vue.use(Forms);
        Vue.use(ProgressBar);
        Vue.use(Snotify);
        Vue.use(VueSelect);
        Vue.use(Excel);
        Vue.use(Filters);
        Vue.use(Directives);
        Vue.use(PrintToPaper);
        Vue.use(VueIdle);
        // Vue.use(PerfectScrollbar);
    }
}
